// Thumbnail strip for the product gallery: clicking a thumbnail scrolls the gallery track to that image,
// and the thumbnail of the first visible image is marked aria-current as the shopper scrolls.
class SGalleryThumbs extends HTMLElement {
  #track;
  #buttons = [];
  #onClick = (event) => {
    const button = event.target.closest('[data-thumb-index]');
    if (!button) return;
    this.#scrollTo(Number(button.dataset.thumbIndex));
  };
  #onScroll = () => this.#markCurrent();

  connectedCallback() {
    this.#track = this.parentElement?.querySelector('[data-product-gallery]');
    this.#buttons = [...this.querySelectorAll('[data-thumb-index]')];
    if (!this.#track) return;
    this.addEventListener('click', this.#onClick);
    this.#track.addEventListener('scroll', this.#onScroll, { passive: true });
    this.#markCurrent();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
    this.#track?.removeEventListener('scroll', this.#onScroll);
  }

  #slides() {
    return [...this.#track.children];
  }

  #scrollTo(index) {
    const slides = this.#slides();
    const slide = slides[index];
    if (!slide) return;
    const left = slide.offsetLeft - slides[0].offsetLeft;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.#track.scrollTo({ left, behavior: reduce ? 'auto' : 'smooth' });
  }

  #markCurrent() {
    const slides = this.#slides();
    if (!slides.length) return;
    const origin = slides[0].offsetLeft;
    const position = Math.abs(this.#track.scrollLeft);
    let current = 0;
    slides.forEach((slide, i) => {
      if (slide.offsetLeft - origin <= position + 4) current = i;
    });
    this.#buttons.forEach((button, i) => {
      if (i === current) button.setAttribute('aria-current', 'true');
      else button.removeAttribute('aria-current');
    });
  }
}

if (!customElements.get('s-gallery-thumbs')) {
  customElements.define('s-gallery-thumbs', SGalleryThumbs);
}
